export default {"src":"/_next/static/media/download-file.09bb60b0.svg","height":513,"width":513};